module.exports = __webpack_public_path__ + "img/item14.8f11bda4.png";